// T3-B sponsored motif (PR 4, 2026-05-07): sponsored_campaigns CRUD endpoints HTTP client.
// api 側 implementation: omikuji-api PR #97。
//
// auth: ADMIN only。

import ApiService from './ApiService';

export default class SponsoredCampaignApi extends ApiService {
    // GET /system/sponsored-campaigns?status=&sponsor_id=&page=&limit=
    list(payload?: any) {
        return this.get('sponsored-campaigns', payload);
    }

    getById(id: string | number) {
        return this.get(`sponsored-campaigns/${id}`);
    }

    create(payload: any) {
        return this.post('sponsored-campaigns', payload);
    }

    update(payload: { id: string | number, data: any }) {
        const { id, data } = payload;
        return this.put(`sponsored-campaigns/${id}`, data);
    }

    // PUT /system/sponsored-campaigns/:id/status
    changeStatus(payload: { id: string | number, status: string }) {
        const { id, status } = payload;
        return this.put(`sponsored-campaigns/${id}/status`, { status });
    }

    // status='draft' のみ削除可 (= backend 制約、それ以外は changeStatus で 'ended' に)
    remove(id: string | number) {
        return this.delete(`sponsored-campaigns/${id}`);
    }
}
